// extracted by mini-css-extract-plugin
module.exports = {"card":"activity-card_card__2zzAU","right":"activity-card_right__3kBSB","title":"activity-card_title__D5F0N","createTime":"activity-card_createTime__3eJiG"};